import { PropertySpyHome } from 'features/propertySpy/propertySpyHome/ui/PropertySpyHome'

export const PropertyPage = (): JSX.Element => {
   
    return (
        <PropertySpyHome />
    )
}